import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {OrderSuccessPageService_GetOrderSuccessPageLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/order_success_page/v1/service.grpc.lazy';
import {useQueryParams} from '@aboutyou/router';
import {useTrackOspError} from '@aboutyou/tracking';
import {ContentPopperProps, LoadingPageSpinner} from '@aboutyou/ui-components';
import {useFullSession, useUser} from '@aboutyou/user';
import React, {useEffect} from 'react';
import {OrderSuccessPageStreamView} from './OrderSuccessPageStreamView';
import {OSPErrorView} from './OspErrorView';

const useOspSession = () => {
  const session = useFullSession();
  const {data} = useUser();

  if (session?.type.$case === 'guest' && data && 'guestToken' in data) {
    return {
      type: {
        $case: 'customer' as const,
        customer: {
          authToken: data.guestToken!,
        },
      },
    };
  } else {
    return session;
  }
};

const useStream = (token: string | null) => {
  const session = useOspSession();
  const trackOspError = useTrackOspError();

  return useGrpcRequest(
    OrderSuccessPageService_GetOrderSuccessPageLazy,
    {
      continuationToken: null,
      elementCount: 100,
      cbdToken: token!,
      session: session!,
    },
    {
      disabled: !token || !session,
      onError: () => {
        trackOspError('Network request failed');
      },
    },
  );
};

const Error = () => {
  const trackOspError = useTrackOspError();

  useEffect(() => {
    trackOspError('Unexpected error happened while requesting OSP');
  }, []);

  return <OSPErrorView />;
};

export const OrderSuccessPageStream = (props: {
  className?: string;
  ContentPopperLayoutComponent: ContentPopperProps['LayoutComponent'];
}) => {
  const params = useQueryParams();
  const token = params.get('cbd');

  return (
    <DataFetcher
      request={useStream(token)}
      Error={Error}
      View={OrderSuccessPageStreamView}
      viewProps={{cbdParameter: token!, ...props}}
      Loading={LoadingPageSpinner}
    />
  );
};
